module.exports = __webpack_public_path__ + "static/media/ionicons.99b86349.woff";